module.exports = __webpack_public_path__ + "static/6305-woodrose-36-4c8a15bc8b468d79927901427ab27b5e.jpg";